import { render, staticRenderFns } from "./listaProdutosLegada.vue?vue&type=template&id=567c8a50&scoped=true"
import script from "./listaProdutosLegada.vue?vue&type=script&lang=js"
export * from "./listaProdutosLegada.vue?vue&type=script&lang=js"
import style0 from "./listaProdutosLegada.vue?vue&type=style&index=0&id=567c8a50&prod&lang=css"
import style1 from "./listaProdutosLegada.vue?vue&type=style&index=1&id=567c8a50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567c8a50",
  null
  
)

export default component.exports